export const HOST_POWER_STATUS = 'HOST_POWER_STATUS';
